import React, { FC } from 'react';
import { Text } from 'components/_temp_ui_common/theme/Text';
import axiosInstance from 'helpers/axiosInstance';
import HeadHYP1 from 'public/assets/img/buddies/Head-HYP-1.gif';

import { LeadProgram, LeadProgramColor } from '../../constants';
import Links from '../Links';
import PhoneLink from '../PhoneLink';
import NpWhatsThisModal from './NpWhatsThisModal';

const NpSignUpConfirmation: FC<{
  email: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  program: LeadProgram;
}> = ({ program, email, first_name, last_name, phone_number }) => {
  const [baseUrl, setBaseUrl] = React.useState('');
  const [showWhatIsThisModal, setShowWhatIsThisModal] = React.useState(false);

  const handleWhatIsThisClick = () => {
    setShowWhatIsThisModal(true);
  };

  React.useEffect(() => {
    axiosInstance
      .get<{
        url: string;
      }>(`/${program}/healthie_intake_appointment_url`)
      .then(resp => {
        setBaseUrl(resp.data.url);
      });
  }, []);

  return (
    <>
      {showWhatIsThisModal && (
        <NpWhatsThisModal setShowModal={setShowWhatIsThisModal} />
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:px-8">
        <div className="flex flex-col px-4 py-4 text-center lg:text-left">
          <div className="order-1 md:order-none">
            <div className="pb-6 flex justify-center lg:justify-start">
              <img
                src={HeadHYP1}
                className="h-20 w-20 lg:h-32 lg:w-32 rounded-full"
                style={{
                  backgroundColor: '#e6d5f1',
                }}
              />
            </div>

            <div className="flex flex-col w-full items-center lg:items-start px-2 lg:px-4">
              <Text
                variant="h3"
                className="font-black text-4xl text-purple-700 mb-3"
                style={{ color: LeadProgramColor.np }}
              >
                Request received!
              </Text>
              <Text variant="body-2" className="mb-6">
                Thank you for taking the first step to a Neuropsychological
                Evaluation with Bend Health.
              </Text>

              <div className="flex flex-col gap-2 mb-8">
                <Text
                  variant="body-5"
                  bold
                  className="mt-6"
                  style={{ color: LeadProgramColor.np }}
                >
                  NEXT UP:
                </Text>

                <div className="flex flex-col sm:flex-row w-full items-start gap-2">
                  <Text variant="body-3" bold className="text-xl text-left">
                    Schedule your Clinical Intake Appointment
                  </Text>

                  <Text
                    variant="body-4"
                    bold
                    className="text-[#018847] whitespace-nowrap mt-1"
                  >
                    <button onClick={handleWhatIsThisClick} className="!inline">
                      <Text
                        variant="body-5"
                        bold
                        className="hover:underline !inline"
                        style={{ color: '#018847' }}
                      >
                        What&apos;s this?
                      </Text>
                    </button>
                  </Text>
                </div>
              </div>
            </div>
          </div>

          <div className="order-2 md:hidden p-4">
            <iframe
              src={`${baseUrl}&${new URLSearchParams({
                email,
                first_name,
                last_name,
                phone_number,
              }).toString()}`}
              className="w-full rounded-lg border border-gray-200 shadow-lg py-4"
              style={{
                height: 700,
              }}
            />
          </div>

          <div className="order-3 md:order-none w-100 mt-2 text-lg text-left px-2 lg:px-4">
            <div className="mb-4">
              <p
                style={{
                  width: '2rem',
                  height: '0.25rem',
                  borderRadius: '6.25rem',
                  background: '#FFAFB4',
                }}
              ></p>
            </div>

            <Text variant="body-4">
              Answers to frequently asked questions can be found in our{' '}
              <Links
                url="https://www.bendhealth.com/neuropsych-welcome-guide"
                target="_blank"
                text="welcome guide."
                textVariant="body-4"
                bold={true}
              />{' '}
              Please connect with us at{' '}
              <PhoneLink phone="(800) 516-0975" bold={true} /> if you have any
              remaining questions.
            </Text>
          </div>
        </div>

        <div className="hidden md:block p-4">
          <iframe
            src={`${baseUrl}&${new URLSearchParams({
              email,
              first_name,
              last_name,
              phone_number,
            }).toString()}`}
            className="w-full rounded-lg border border-gray-200 shadow-lg py-4"
            style={{
              height: 600,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default NpSignUpConfirmation;
